// extracted by mini-css-extract-plugin
export default {"conference":"Gpxad7qMmwd7a2qG8tVi","header":"JUqe0bg8HEQ6zHyOzIYY","pageTitle":"eayEV8ATfbPYHq0epF_w","actions":"AVkWpU1vjlV2zmlwYxq1","modalConfirm":"Qou6eprrFlJZIzrGUlE3"};